export const breakpoints = {
  xs: 0,
  sm: 768,
  md: 1024,
  lg: 1280,
  xl: 1920,
};

export const colors = {
  logo: {
    yellow: "#f0a91d",
    red: "#A30000",
  },
  blue: {
    primary: "#00aed9", // links, primary buttons, icons
    hover: "#018dc0", // hover state
    medium: "#00619e", // sticky header background
    dark: "#183558", // navigation header background, headlines, text
    pastel: "#cfeaf2", // accent
  },
  gray: {
    background: "#f4f8fa", // main background within 1800px
    light: "#d9dde9", // secondary copy, tabs and field outlines, lines
    medium: "#aab1c7", // icons, unselected heart icon
    dark: "#757989", // text and icons
  },
  green: {
    primary: "#1dd08b", // success green
  },
  red: {
    primary: "#ff7171", // alert red, faved
  },
  yellow: {
    primary: "#feb948", // secondary buttons, attentions icons
    hover: "#eb9f23", // hover state
    pastel: "#fbf2de", // accent
  },
  white: {
    primary: "#ffffff",
  },
  black: {
    primary: "#000000",
  },
  stroke: {
    blue: "#122946", // divider line color in header and footer
  },
};
